import { generateEventMap } from 'events/lib'
import { useEvent } from 'events/useEvent'

type EMap = ReturnType<typeof generateEventMap>

export function useModalCloseEvent<T extends keyof EMap> (
  ns: T,
  elementId: keyof EMap[T],
  onClose: () => void
) {
  const { fireEvent: closeEvent } = useEvent(ns)
  const handleClose = () => {
    closeEvent(elementId)
    onClose()
  }
  return handleClose
}
